import { render, staticRenderFns } from "./HonorEdit.vue?vue&type=template&id=028848c8"
import script from "./HonorEdit.vue?vue&type=script&lang=js"
export * from "./HonorEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports